import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch (e) {
      setSettings({});
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Apply theme colors as CSS variables
  useEffect(() => {
    if (!settings?.colors) return;
    const root = document.documentElement;
    const c = settings.colors;
    if (c.background) root.style.setProperty("--brand-bg", c.background);
    if (c.surface) root.style.setProperty("--brand-surface", c.surface);
    if (c.surface_elevated) root.style.setProperty("--brand-surface-elevated", c.surface_elevated);
    if (c.primary) root.style.setProperty("--brand-primary", c.primary);
    if (c.primary_hover) root.style.setProperty("--brand-primary-hover", c.primary_hover);
    if (c.text_primary) root.style.setProperty("--brand-text", c.text_primary);
    if (c.text_secondary) root.style.setProperty("--brand-text-secondary", c.text_secondary);
    if (c.border) root.style.setProperty("--brand-border", c.border);
  }, [settings]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used within SettingsProvider");
  return ctx;
};
